import React from 'react';
import type { SiteRagReport } from '../../../../types/siteRag';
import { walkCitationText } from '../../../../lib/walkCitationText';
import { useEffectiveReportTheme } from '../../../../lib/useEffectiveReportTheme';
import { roleColor } from '../../../../lib/reportRoleColors';
import { EditorialSubsection } from '../../report/editorial';
import { SectionShell } from '../SectionShell';

export const SupplyChainActionPlanSection: React.FC<{ report: SiteRagReport; label: string }> = ({ report, label }) => {
  const theme = useEffectiveReportTheme();
  const recs = report.recommendations ?? [];
  const hasData = recs.length > 0;

  return (
    <SectionShell label={label} hasData={hasData} report={report} sectionId="actionPlan" required>
      <div className="space-y-3">
        {recs.map((rec, idx) => (
          <EditorialSubsection
            key={`${rec.type}-${idx}`}
            theme={theme}
            label={rec.type}
            accentLabel
          >
            <div className="text-sm font-bold" style={{ color: roleColor(theme, 'ink') }}>{rec.title}</div>
            {rec.description && (
              <p className="text-xs leading-relaxed mt-1 mb-0" style={{ color: roleColor(theme, 'body') }}>
                {walkCitationText(rec.description, report.references)}
              </p>
            )}
          </EditorialSubsection>
        ))}
      </div>
    </SectionShell>
  );
};
